export default __webpack_public_path__ + "static/media/eight.785832c0.jpeg";